import { WarningCircle } from 'phosphor-react'

import { Button } from '../../../../../../components/Button'
import { DialogModal } from '../../../../../../components/DialogModal'

type UnarquiveProjectModalProps = {
  isOpen: boolean
  isUnarchivingProject: boolean
  onUnarquiveProject: () => void
  onClose: () => void
}

export const UnarquiveProjectModal = ({
  isOpen,
  isUnarchivingProject,
  onClose,
  onUnarquiveProject,
}: UnarquiveProjectModalProps) => {
  return (
    <DialogModal isOpen={isOpen} onClose={onClose}>
      <div className="px-8 pb-6">
        <WarningCircle size={72} className="mx-auto mb-10 text-primary-light" />
        <p className="text-center text-grey-900">
          Você está prestes a desarquivar um projeto.
        </p>
        <p className="text-center mb-14 text-grey-900">Deseja continuar?</p>

        <div className="flex items-center gap-2">
          <Button type="button" variant="outline" onClick={onClose} fullWidth>
            Cancelar
          </Button>
          <Button
            type="button"
            variant="primary"
            isLoading={isUnarchivingProject}
            onClick={onUnarquiveProject}
            fullWidth
          >
            Continuar
          </Button>
        </div>
      </div>
    </DialogModal>
  )
}
